import Vue from 'vue'
import Vuex from 'vuex'

import viewData from './modules/views'
import userData from './modules/user'
import tokenData from './modules/tokens'
import mapData from './modules/map'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {
		viewData,
		userData,
		tokenData,
		mapData
	},
	strict: debug
});
